import React from 'react';
import './Hero.css';

const Hero = () => {
  const handleAppStoreClick = () => {
    window.open('https://apps.apple.com/app/slimbuddy', '_blank');
  };

  const handleLearnMoreClick = () => {
    const featuresSection = document.getElementById('features');
    if (featuresSection) {
      featuresSection.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  return (
    <section className="hero">
      <div className="hero-content">
        <div className="hero-text">
          <div className="hero-logo">
            <img src="/android-chrome-192x192.png" alt="SlimBuddy Logo" className="logo" />
          </div>
          <h1 className="hero-title">
            Meet Your AI-Powered
            Weight Loss Companion
          </h1>
          <p className="hero-description">
            SlimBuddy uses cutting-edge AI to help you track calories, optimize workouts, 
            and achieve your weight loss goals with personalized guidance every step of the way.
          </p>
          <div className="hero-buttons">
            {/* <button className="app-store-btn" onClick={handleAppStoreClick}>
              <img src="/images/app-store-badge.svg" alt="Download on the App Store" />
            </button> */}
            <div className="hero-stats">
            <div className="coming-soon-widget">
              <span className="coming-soon-text">Coming Soon</span>
            </div>
          </div>
            <button className="learn-more-btn" onClick={handleLearnMoreClick}>
              Learn More
            </button>
          </div>
        </div>
        <div className="hero-image">
          <div className="phone-mockup">
            <img src="/images/slimbuddy_phone.png" alt="SlimBuddy App Screenshot" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;